export default __webpack_public_path__ + "static/media/ico-sq-5-gender.475d53bf.svg";